import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  productSections: [],
  isLoading: false
})

const getters = {
  productSections: (state) => state.productSections,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_PRODUCT_SECTIONS(state, payload) {
    state.productSections = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchProductSections({ commit, dispatch }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get('/api/dashboard/section')
      .then((res) => {
        commit('SET_PRODUCT_SECTIONS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createProductSection({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/section`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/product-sections')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteProductSection(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/section/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchProductSection(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/section/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.imageUrl = message.image
        vm.editForm.name_en = message.name_en
        vm.editForm.name_ru = message.name_ru
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateProductSection(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/section/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editProductSectionModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
